
import { useEffect, useState } from 'react';
import { IUsuario } from '@/@types/Comunidade';
import { api } from '@/services/api';
import { DocenteItem } from '@/components/PagesComponents/Comunidade/DocenteItem';
import { Loading } from '@/components/shared/Loading';


interface IProfessorColaborador extends IUsuario {
}

// const tipoDocenteDescricoes = [
//     'Docente Pleno - Pós-graduação', 0
//     'Docente Participante', 1
//     'PPPD - Pós-graduação', 2
//     'PAD', 3
//     'PED', 4
//     'Pesquisador Colaborador', 5
//     'Pesquisador Visitante Convidado', 6
//     'Professor Colaborador', 7
//     'Visitante' 8
// ];

const ProfessorColaborador = () => {
    const [professoresColaboradores, setProfessoresColaboradores] = useState<IProfessorColaborador[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getProfessorColaborador = async () => {
            setIsLoading(true);
            const url = 'user/register/TipoDocentes/7';

            await api.get(url)
                .then(response => {
                    setProfessoresColaboradores(response.data)
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => setIsLoading(false));
        }

        getProfessorColaborador();

    }, [])

    return (
        <>
            <h1>Professor Colaborador</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <div>
                    {professoresColaboradores.map(professor => (
                        <DocenteItem key={professor._id} data={professor} />
                    ))}
                </div>
            )}
        </>
    );
}

export { ProfessorColaborador }